export default __webpack_public_path__ + "static/media/bank4.9478b5b6.png";